import React from 'react';
import ReactDOM from 'react-dom';
import Tips from './screens/Tips';
import './styles/styles.scss'


ReactDOM.render(
  <React.StrictMode>
    <Tips />
  </React.StrictMode>,
  document.getElementById('root')
);

